import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Group } from '../shared/interfaces/group.interface';

@Injectable({
  providedIn: 'root',
})
export class GroupService {
  constructor(private http: HttpClient) {}

  url = '@cec-api/groups';
  get(): Promise<any> {
    return this.http.get(this.url).toPromise();
  }

  getAll(): Promise<any> {
    return this.http.get(`@cec-api/celulas`).toPromise();
  }
  getGroupFunctions(): Promise<any> {
    return this.http.get(this.url + 'Functions').toPromise();
  }

  getById(id: number): Promise<any> {
    return this.http.get(this.url + '/' + id).toPromise();
  }

  addGroup(user: Group): Promise<any> {
    return this.http.post(this.url, user).toPromise();
  }

  updateGroup(user: Group, id: number): Promise<any> {
    return this.http.put(this.url + '/' + id, user).toPromise();
  }

  deleteUser(id: number) {
    return this.http.delete(this.url + '/' + id).toPromise();
  }

  search(searchValue: string): Promise<any> {
    return this.http.get(this.url + '/search?name=' + searchValue).toPromise();
  }
}
